import React, { useContext, useState } from "react";
import { usePermissions } from "./App";
import {
  faAdd,
  faCancel,
  faCheckCircle,
  faClose,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MessageModal from "./MessageModal";
import useSWR from "swr";
import TableTotalNCost from "./TableTotalNCost";
import DashboardContenLeftMenus from "./DashboardContenLeftMenus";
import DashboardContentHeader from "./DashboardContentHeader";
import DashboardContentFooter from "./DashboardContentFooter";
import TopActionMenus from "./TopActionMenus";
import AddVoucherCategory from "./AddVoucherCategory.js";

import SearchFilter from "./SearchFilter";
import { NavigationContext } from "navigation-react";
import LoaderAnimation from "./LoaderAnimation";
import SecureLS from "secure-ls";
import AddVoucher from "./AddVoucher.js";
import EditClientAttachedToVoucherManager from "./EditClientAttachedToVoucherManager.js";

const ls = new SecureLS({ encodingType: "aes" });

function parseDate(dateStr) {
  if (!dateStr) return null;
  const isoDate = new Date(dateStr);
  if (!isNaN(isoDate.getTime())) return isoDate;
  const parts = dateStr.split("/");
  if (parts.length === 3) {
    const [day, month, year] = parts.map(Number);
    const parsedDate = new Date(year, month - 1, day);
    if (!isNaN(parsedDate.getTime())) return parsedDate;
  }
  return null;
}

const ScreeningContentManager = () => {
  // eslint-disable-next-line no-unused-vars
  const { stateNavigator } = useContext(NavigationContext);
  const [isMessageModalIsNotOk, setIsMessageModalIsNotOk] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [modalMessages, setModalMessages] = useState("");
  const [modalAddRequest, setModalAddRequest] = useState(false);
  const [modalAddVoucher, setModalAddVoucher] = useState(false);
  const toggleModalEditRequest = () => setModalEditRequest(!modalEditRequest);
  const [modalEditRequest, setModalEditRequest] = useState(false);

  // eslint-disable-next-line no-unused-vars
  const [clientDataAttachVoucher, setclientDataAttachVoucher] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const perm = usePermissions();

  const [searchTerm, setSearchTerm] = useState("");
  const [voucherGenerationStartDate, setVoucherGenerationStartDate] =
    useState("");
  const [voucherGenerationEndDate, setVoucherGenerationEndDate] = useState("");
  const [categoryFilter, setCategoryFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [clientDataForEditState, setClientDataForEditState] = useState("");

  const [isMessageModalError, setIsMessageModalError] = useState(false);
  const [modalSuccessMsg, setModalSuccessMsg] = useState(false);

  const toggleModalAddRequest = () => {
    setModalAddRequest(!modalAddRequest);
  };

  const toggleModalAddVoucherTaxTerms = () => {
    setModalAddVoucher(!modalAddVoucher);
  };

  const username = ls.get("username");
  const userpw = ls.get("userpw");
  const usercsrf_token = ls.get("usercsrf_token");

  const fetcher = (url) =>
    fetch(url, {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Basic ${btoa(`${username}:${userpw}`)}`,
        "X-CSRF-Token": usercsrf_token,
      },
    })
      .then((res) => res.json())
      .then((data) => (Array.isArray(data) ? data : [data]));

  const {
    data: voucherData,
    error: voucherDataError,
    isLoading: voucherDataLoading,
  } = useSWR(
    `${process.env.REACT_APP_VOUCHER_SCREENING_CONTENT_EDITOR_API}`,
    fetcher
  );

  const { data: categories = [] } = useSWR(
    `${process.env.REACT_APP_VOUCHER_TAXONOMY_CATEGORIES_TERM_API}?_format=json`,
    fetcher
  );

  const categoryOptions = categories.map((term) => ({
    tid: term.tid,
    name: term.name,
  }));

  const filteredData = Array.isArray(voucherData)
    ? voucherData.filter((request) => {
        const matchesSearchTerm =
          request.field_voucher_code
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_first_name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_last_name
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_date_of_birth
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          request.field_gender
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_contact_number
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_client_email_address
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          request.field_location
            ?.toLowerCase()
            .includes(searchTerm.toLowerCase());

        const matchesStatus =
          !statusFilter ||
          request.field_status?.toLowerCase() === statusFilter.toLowerCase();

        const categoryName = categoryOptions.find(
          (opt) => opt.tid === categoryFilter
        )?.name;

        const matchesCategory =
          !categoryFilter || request.term_node_tid === categoryName;

        const requestDate = parseDate(request.field_generation_date);
        const reqStart = voucherGenerationStartDate
          ? new Date(voucherGenerationStartDate)
          : null;
        const reqEnd = voucherGenerationEndDate
          ? new Date(voucherGenerationEndDate)
          : null;

        if (reqStart) reqStart.setHours(0, 0, 0, 0);
        if (reqEnd) reqEnd.setHours(23, 59, 59, 999);
        if (requestDate) requestDate.setHours(12, 0, 0, 0);

        const isInRequestDateRange =
          (!reqStart || (requestDate && requestDate >= reqStart)) &&
          (!reqEnd || (requestDate && requestDate <= reqEnd));

        return (
          matchesSearchTerm &&
          matchesStatus &&
          matchesCategory &&
          isInRequestDateRange
        );
      })
    : [];

  const toggleModalSuccessMsg = () => setModalSuccessMsg(!modalSuccessMsg);
  const toggleModalError = () => setIsMessageModalError(!isMessageModalError);
  const toggleModalIsNotOk = () =>
    setIsMessageModalIsNotOk(!isMessageModalIsNotOk);

  if (voucherDataError) {
    return (
      <LoaderAnimation
        loadingTxt={`Check your network / internet connection and try again!, ${voucherDataError}`}
      />
    );
  }

  if (voucherDataLoading) {
    return <LoaderAnimation loadingTxt="Loading..." />;
  }

  return (
    <div className="dashboard-container">
      <DashboardContentHeader />
      <div className="content-wrapper">
        <DashboardContenLeftMenus />
        <div className="patient-register">
          <TopActionMenus
            AddTitle="Voucher Register"
            onClick={toggleModalAddRequest}
            buttonLabel="Generate Voucher"
            onClickIcon={`${faAdd}`}
            buttonLabelAddVoucherCat={"Add Voucher Categories"}
            onClickIconAddVoucherCat={`${faPlus}`}
            onClickAddVoucherCat={toggleModalAddVoucherTaxTerms}
          />{" "}
          <SearchFilter
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            statusFilter={statusFilter}
            setStatusFilter={setStatusFilter}
            voucherGenerationStartDate={voucherGenerationStartDate}
            setVoucherGenerationStartDate={setVoucherGenerationStartDate}
            voucherGenerationEndDate={voucherGenerationEndDate}
            setVoucherGenerationEndDate={setVoucherGenerationEndDate}
            categoryFilter={categoryFilter}
            setCategoryFilter={setCategoryFilter}
            categoryOptions={categoryOptions}
          />
          {filteredData.length > 0 ? (
            <table>
              <thead>
                <tr>
                  <td>Voucher Code</td>
                  <td>Category</td>
                  <td>First Name</td>
                  <td>Last Name</td>
                  <td>Gender</td>
                  <td>Date of Birth</td>
                  <td>Contact Number</td>
                  <td>Email Address</td>
                  <td>Location</td>
                  <td>Generation Date</td>
                  <td>Expiration Date</td>
                  <td>Redeemed Date</td>
                  <td>Status</td>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                {filteredData.map((row) => (
                  <tr key={row.voucher_nid}>
                    <td>{row.field_voucher_code}</td>
                    <td>{row.term_node_tid}</td>
                    <td>{row.field_first_name}</td>
                    <td>{row.field_last_name}</td>
                    <td>{row.field_gender}</td>
                    <td>{row.field_date_of_birth}</td>
                    <td>{row.field_contact_number}</td>
                    <td>{row.field_client_email_address}</td>
                    <td>{row.field_location}</td>
                    <td>{row.field_generation_date}</td>
                    <td>{row.field_expiration_date}</td>
                    <td>{row.field_redeemed_date}</td>
                    <td>{row.field_status}</td>
                    <td>
                      <button
                        className="btn-modal"
                        onClick={() => {
                          toggleModalEditRequest();
                          setClientDataForEditState(row);
                        }}
                      >
                        Edit client
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <LoaderAnimation loadingTxt="No matching records found" />
          )}
          {filteredData?.length > 0 && (
            <TableTotalNCost
              noOfReportLable="Number of vouchers :"
              noOfReportLength={filteredData?.length}
              totalRequestFeeCostValue={filteredData.reduce((total, report) => {
                const amount = Number(report?.field_payment_amount) || 0;
                return total + amount;
              }, 0)}
            />
          )}
          {modalAddRequest && (
            <div className="modal">
              <div className="overlay"></div>
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-header">
                    <p>Add new Voucher</p>
                    <button
                      className="close-modal"
                      onClick={toggleModalAddRequest}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </button>
                  </div>

                  <AddVoucher />
                </div>
              </div>
            </div>
          )}
          {modalAddVoucher && (
            <div className="modal">
              <div className="overlay"></div>
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-header">
                    <p>Add new Voucher Category</p>
                    <button
                      className="close-modal"
                      onClick={toggleModalAddVoucherTaxTerms}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </button>
                  </div>

                  <AddVoucherCategory />
                </div>
              </div>
            </div>
          )}
          {modalEditRequest && (
            <div className="modal">
              <div className="overlay"></div>
              <div className="modal-content">
                <div className="modal-body">
                  <div className="modal-header">
                    <p>Edit Client Bio Data</p>
                    <button
                      className="close-modal"
                      onClick={toggleModalEditRequest}
                    >
                      <FontAwesomeIcon icon={faClose} />
                    </button>
                  </div>
                  <EditClientAttachedToVoucherManager
                    clientDataForEditState={clientDataForEditState}
                  />
                </div>
              </div>
            </div>
          )}
          {modalSuccessMsg && (
            <MessageModal
              leftIcon={faCheckCircle}
              color="green"
              fontSize={20}
              message="Request updated successfully!"
              onClose={() => setModalSuccessMsg(false, toggleModalSuccessMsg())}
              rightIcon={faClose}
            />
          )}
          {isMessageModalError && (
            <MessageModal
              leftIcon={faCancel}
              color="red"
              fontSize={20}
              message="This request is complete. Editing is not allowed."
              onClose={() => {
                toggleModalError();
              }}
              rightIcon={faClose}
            />
          )}
          {isMessageModalIsNotOk && (
            <MessageModal
              leftIcon={faCancel}
              color="red"
              fontSize={20}
              message={modalMessages}
              onClose={() => {
                toggleModalIsNotOk();
              }}
              rightIcon={faClose}
            />
          )}
        </div>
      </div>

      <DashboardContentFooter />
    </div>
  );
};

export default ScreeningContentManager;
